import api from './api';

class VendorRegistrationService {
    /**
     * Request OTP for new vendor registration
     * @param {string} mobile - Mobile number
     * @returns {Promise} API response
     */
    async newVendorLogin(mobile) {
        try {
            const response = await api.post('/vendor-registrations/new-vendor/login', {
                mobile_number: mobile
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    /**
     * Verify OTP for new vendor registration
     * @param {string} mobile - Mobile number
     * @param {string} otp - One-time password
     * @returns {Promise} API response with user data and token
     */
    async newVendorVerifyOTP(mobile, otp) {
        try {
            const response = await api.post('/vendor-registrations/new-vendor/verify-otp', {
                mobile_number: mobile,
                otp_code: otp
            });
            
            // Store token in localStorage
            if (response.data.access_token) {
                localStorage.setItem('vendor_token', response.data.access_token);
            }
            
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    /**
     * Create new vendor registration
     * @param {Object} registrationData - Vendor registration data
     * @returns {Promise} API response
     */
    async createNewVendorRegistration(registrationData) {
        try {
            const response = await api.post('/vendor-registrations/new', registrationData);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    /**
     * Create vendor registration for specific entity type
     * @param {Object} registrationData - Vendor registration data with entity type
     * @returns {Promise} API response
     */
    async createVendorRegistration(registrationData) {
        try {
            const response = await api.post('/vendor-registrations/', registrationData);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    /**
     * Get registrations for current user
     * @param {string} approvalStatus - Optional approval status filter
     * @returns {Promise} API response
     */
    async getMyRegistrations(approvalStatus = null) {
        try {
            const params = approvalStatus ? { approval_status: approvalStatus } : {};
            const response = await api.get('/vendor-registrations/my-registrations', { params });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    /**
     * Submit a draft registration for approval
     * @param {number} registrationId - Registration ID
     * @returns {Promise} API response
     */
    async submitRegistration(registrationId) {
        try {
            const response = await api.put(`/vendor-registrations/${registrationId}/submit`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    /**
     * Update vendor registration data
     * @param {number} registrationId - Registration ID
     * @param {Object} updateData - Data to update
     * @returns {Promise} API response
     */
    async updateRegistration(registrationId, updateData) {
        try {
            const response = await api.put(`/vendor-registrations/${registrationId}`, updateData);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    /**
     * Get vendor registration by ID
     * @param {number} registrationId - Registration ID
     * @returns {Promise} API response
     */
    async getRegistrationById(registrationId) {
        try {
            const response = await api.get(`/vendor-registrations/${registrationId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async getAllServiceTypes() {
        try {
            const response = await api.get('/vendor-registrations/service-types');
            return response.data;
        } catch (error) {
            console.error('Error fetching service types:', error);
            throw error;
        }
    }

    async getServiceSubtypes(serviceTypeCode) {
        try {
            const response = await api.get(`/vendor-registrations/service-types/${serviceTypeCode}/subtypes`);
            return response.data;
        } catch (error) {
            console.error('Error fetching service subtypes:', error);
            throw error;
        }
    }
}

export const vendorRegistrationService = new VendorRegistrationService(); 